import { Box, Link } from '@chakra-ui/react'
import { FaBuilding, FaCrown, FaUsers } from 'react-icons/fa'
import { IoFlash } from 'react-icons/io5'
import { PlanCode } from '../../types/subscription'
import { Plan } from './components/PricePlansComponents'

export const PRICE_PLAN_LABEL: Record<PlanCode, string> = {
  [PlanCode.STANDARD]: 'Standard',
  [PlanCode.UNLIMITED]: 'Unlimited',
  [PlanCode.UNLIMITED_ONE_YEAR]: 'Unlimited One Year',
  [PlanCode.LITE]: 'Lite',
  [PlanCode.PRO]: 'Pro',
  [PlanCode.TEAM_STARTER]: 'Team Starter',
  [PlanCode.TEAM_PRO]: 'Team Pro',
  [PlanCode.ENTERPRISE]: 'Enterprise',
}

export const PRICE_PLAN_UNIT_PRICE: Partial<Record<PlanCode, number>> = {
  [PlanCode.LITE]: 35,
  [PlanCode.PRO]: 65,
  [PlanCode.TEAM_STARTER]: 79,
  [PlanCode.TEAM_PRO]: 89,
  [PlanCode.STANDARD]: 35,
  [PlanCode.UNLIMITED]: 65,
  [PlanCode.UNLIMITED_ONE_YEAR]: 702,
}

export const INDIVIDUAL_PLANS: Plan[] = [
  {
    id: PlanCode.LITE,
    name: 'Lite',
    icon: IoFlash,
    price: PRICE_PLAN_UNIT_PRICE[PlanCode.LITE],
    priceLabel: 'per user per month',
    description: 'Perfect for individual practitioners getting started',
    features: [
      { text: '30 scripts per month', included: true },
      { text: 'Unlimited free admin users', included: true },
      { text: 'Send script via SMS and email', included: true },
      { text: 'Self-managed billing for multiple users', included: true },
      { text: 'Real Time Prescription Monitoring(RTPM)', included: true },
    ],
    buttonText: 'Get Started',
    buttonVariant: 'secondary',
    note: 'No credit card needed for free trial',
    pricePlan: PlanCode.LITE,
  },
  {
    id: PlanCode.PRO,
    name: 'Pro',
    icon: FaCrown,
    price: PRICE_PLAN_UNIT_PRICE[PlanCode.PRO],
    priceLabel: 'per user per month',
    description: 'For busy practitioners who need more flexibility',
    features: [
      { text: 'Everything in Lite plan, plus:', included: true, showIcon: false },
      { text: 'Unlimited tokens per month', included: true },
      { text: 'Create multiple scripts', included: true },
      { text: 'Renew scripts (Coming soon)', included: false },
    ],
    buttonText: 'Get Started',
    buttonVariant: 'secondary',
    popular: true,
    note: 'No credit card needed for free trial',
    pricePlan: PlanCode.PRO,
  },
]

export const TEAM_PLANS: Plan[] = [
  {
    id: PlanCode.TEAM_STARTER,
    name: 'Team Starter',
    icon: FaUsers,
    price: PRICE_PLAN_UNIT_PRICE[PlanCode.TEAM_STARTER],
    priceLabel: 'per user per month',
    description: 'Unlimited prescriptions for growing teams',
    features: [
      { text: 'Everything in Pro plan, plus:', included: true, showIcon: false },
      { text: 'Share organization patients', included: true },
    ],
    buttonText: 'Get Started',
    buttonVariant: 'primary',
    note: 'No credit card needed for free trial',
    pricePlan: PlanCode.TEAM_STARTER,
    seatCustomizable: true,
  },
  {
    id: PlanCode.TEAM_PRO,
    name: 'Team Pro',
    icon: FaUsers,
    price: PRICE_PLAN_UNIT_PRICE[PlanCode.TEAM_PRO],
    priceLabel: 'per user per month',
    description: 'Unlimited prescriptions for growing teams',
    features: [
      { text: 'Everything in Team Starter plan, plus:', included: true, showIcon: false },
      { text: 'Manage multiple locations (Coming soon)', included: false },
    ],
    buttonText: 'Get Started',
    buttonVariant: 'primary',
    note: 'No credit card needed for free trial',
    pricePlan: PlanCode.TEAM_PRO,
    seatCustomizable: true,
  },
  {
    id: PlanCode.ENTERPRISE,
    name: 'Enterprise',
    icon: FaBuilding,
    priceLabel: 'Contact us',
    description: 'For organisations intending to purchase 50+ prescribing seats',
    features: [
      { text: 'Everything in Team plan, plus:', included: true, showIcon: false },
      { text: 'Single Sign On (SSO)', included: true },
      { text: 'Priority Customer Support', included: true },
      { text: 'API Integrations *', included: true },
    ],
    buttonText: 'Talk to Us',
    buttonVariant: 'primary',
    note: (
      <Box>
        * Please complete the{' '}
        <Link color="customBlue.100" target="_blank" href="https://forms.office.com/r/eeY9504g7x">
          RxPad Integration Questionnaire
        </Link>{' '}
        to help us better assess your integration needs.
      </Box>
    ),
    pricePlan: PlanCode.ENTERPRISE,
  },
]
